import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function EditDesignation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [designation, setDesignation] = useState({
    designation_name: "",
    description: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const fetchDesignation = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/designations/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch designation');
        }
        const data = await response.json();
        setDesignation(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDesignation();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUpdating(true);
    setError(null);

    const data = {
      designation_name: designation.designation_name,
      description: designation.description,
    };

    try {
      const response = await fetch(`${BASE_URL}/api/designations/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update designation: ${response.status} ${errorText}`);
      }

      navigate("/admin/DesignationList");
    } catch (err) {
      setError(err.message);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return (
    <div className="p-6 flex justify-center items-center min-h-screen bg-light-grey">
      <div className="text-gold text-xl">Loading...</div>
    </div>
  );
  if (error) return (
    <div className="p-6 flex justify-center items-center min-h-screen bg-light-grey">
      <div className="text-red-500 text-xl">Error: {error}</div>
    </div>
  );

  return (
    <div className="p-6 bg-light-grey min-h-screen">

      {/* PAGE TITLE */}
      <h1 className="text-3xl font-bold text-deep-black mb-8">
        Edit Designation
      </h1>

      {/* FORM CONTAINER */}
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-2xl mx-auto">

        {/* ERROR MESSAGE */}
        {error && (
          <div className="bg-red-100 text-red-700 p-4 rounded-lg mb-6 border border-red-200">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Designation Name */}
          <div>
            <label className="block mb-2 text-deep-black font-semibold text-lg">
              Designation Name
            </label>
            <input
              type="text"
              value={designation.designation_name}
              onChange={(e) => setDesignation({ ...designation, designation_name: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all duration-200"
              placeholder="Enter designation name"
              required
            />
          </div>

          {/* BUTTONS */}
          <div className="flex justify-end gap-4 pt-4">

            {/* CANCEL */}
            <button
              type="button"
              onClick={() => navigate("/admin/DesignationList")}
              className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200 font-semibold"
            >
              Cancel
            </button>

            {/* UPDATE */}
            <button
              type="submit"
              disabled={updating}
              className="px-6 py-3 rounded-lg bg-gold text-deep-black font-semibold hover:bg-gold-dark transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {updating ? "Updating..." : "Update Designation"}
            </button>

          </div>

        </form>

      </div>
    </div>
  );
}
